export const dataTahunFormData = () => {
  return [
    {
      id: "tahun",
      label: "Tahun",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Tahun (e.g : 2019)",
        },
      ],
    },
    {
      id: "status_tahun",
      label: "Status",
      fields: [
        {
          type: "option",
          options: [
            {
              label: "Aktif",
              value: "Aktif",
            },
            {
              label: "Tidak Aktif",
              value: "Tidak Aktif",
            },
          ],
        },
      ],
    },
  ];
};
